module.exports = __webpack_public_path__ + "static/media/Item_Weapon_DP12_C.a2705b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_DP12_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_DP12_C.png
// module chunks = 0